import Orders from './Orders.vue';

export default Orders;
